import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router'; // Import ActivatedRoute and Router
import { TplReportDto } from '../../../dto/tpl-report-dto';
import { TplReportService } from '../../../services/tpl-report.service';
import { FromToDateModel } from '../../../models/from-to-date-model';

@Component({
  selector: 'app-tpl-monthly-report',
  templateUrl: './tpl-monthly-report.component.html',
  styleUrls: ['./tpl-monthly-report.component.css']
})
export class TplMonthlyReportComponent implements OnInit {
  monthYear: string = ''; // Holds the selected month and year in "YYYY-MM" format

  quarterYear: string = ''; // Holds the selected month and year in "YYYY-MM" format

  isLoading = false;
  isLoadingMonth = false;
  isLoadingQuarter = false;
  monthlyReport: TplReportDto | null = null; // Holds the fetched report data
  quarterlyReport: TplReportDto | null = null; // Holds the fetched report data

  constructor(
    private tplReportService: TplReportService,
    private router: Router, // Inject Router to navigate
    private route: ActivatedRoute // Inject ActivatedRoute to get query params
  ) { }

  ngOnInit(): void {
    const today = new Date();
    const lastMonthDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);

    const lastMonth = (lastMonthDate.getMonth() + 1).toString().padStart(2, '0');
    const lastYear = lastMonthDate.getFullYear().toString();

    const monthParam = this.route.snapshot.queryParamMap.get('month') || lastMonth;
    const yearParam = this.route.snapshot.queryParamMap.get('year') || lastYear;

    this.monthYear = `${yearParam}-${monthParam}`;

    this.loadMonthlyReport(this.monthYear);

    // Calculate the quarterYear (e.g., 2025-Q2) from monthYear
    const month = parseInt(monthParam, 10);
    const quarter = Math.floor((month - 1) / 3) + 1;
    this.quarterYear = `${yearParam}-Q${quarter}`;

    // Load quarterly report based on the computed quarter
    this.loadQuarterlyReport(+yearParam, quarter);
  }

  loadQuarterlyReport(year: number, quarter: number): void {

    this.isLoadingQuarter = true;

    const quarterStartMonth = (quarter - 1) * 3;
    const fromDate = new Date(year, quarterStartMonth, 1);
    const toDate = new Date(year, quarterStartMonth + 3, 0); // 0 gets last day of previous month

    const model: FromToDateModel = {
      FromDate: fromDate.toISOString().split('T')[0],
      ToDate: toDate.toISOString().split('T')[0]
    };

    this.isLoading = true;

    this.tplReportService.getQuarterlyTplReport(model).subscribe({
      next: (data) => {
        this.quarterlyReport = data;
        this.isLoading = false;
        this.isLoadingQuarter = false;
        console.log('Quarterly TPL Report:', this.quarterlyReport);
      },
      error: (error) => {
        this.isLoading = false;
        this.isLoadingQuarter = false;
        console.error('Error fetching Quarterly TPL Report:', error);
      }
    });
  }


  loadMonthlyReport(monthYear: string): void {
    this.isLoadingMonth = true;
    const [year, month] = monthYear.split('-');
    const fromDate = new Date(+year, +month - 1, 1); // First day of the month
    const toDate = new Date(+year, +month, 0); // Last day of the month

    const model: FromToDateModel = {
      FromDate: fromDate.toISOString().split('T')[0],
      ToDate: toDate.toISOString().split('T')[0]
    };

    this.isLoading = true;

    this.tplReportService.getMonthlyTplReport(model).subscribe({
      next: (data) => {
        this.monthlyReport = data;
        this.isLoading = false;
        this.isLoadingMonth = false;
        console.log('TPL Report:', this.monthlyReport); // Handle the data as required
      },
      error: (error) => {
        this.isLoading = false;
        this.isLoadingMonth = false;
        console.error('Error fetching TPL Report:', error); // Handle the error appropriately
      }
    });

    // Update the URL query parameters
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { month: month, year: year },
      queryParamsHandling: 'merge'
    });
  }

  gotoPrevMonth(): void {
    const [year, month] = this.monthYear.split('-').map(Number);
    const prevMonthDate = new Date(year, month - 2, 1); // Move to the previous month
    const newMonth = (prevMonthDate.getMonth() + 1).toString().padStart(2, '0');
    const newYear = prevMonthDate.getFullYear().toString();

    this.monthYear = `${newYear}-${newMonth}`;
    this.loadMonthlyReport(this.monthYear);

    // Calculate the quarterYear (e.g., 2025-Q2) from monthYear
    const quarter = Math.floor((month - 1) / 3) + 1;

    const newQuarterYear = `${newYear}-Q${quarter}`;
    if ( newQuarterYear != this.quarterYear ) {
      this.quarterYear = newQuarterYear;

      // Load quarterly report based on the computed quarter
      this.loadQuarterlyReport(+newYear, quarter);
    }
  }

  gotoNextMonth(): void {
    const [year, month] = this.monthYear.split('-').map(Number);
    const nextMonthDate = new Date(year, month, 1); // Move to the next month
    const newMonth = (nextMonthDate.getMonth() + 1).toString().padStart(2, '0');
    const newYear = nextMonthDate.getFullYear().toString();

    this.monthYear = `${newYear}-${newMonth}`;
    this.loadMonthlyReport(this.monthYear);

    // Calculate the quarterYear (e.g., 2025-Q2) from monthYear
    const quarter = Math.floor((month - 1) / 3) + 1;
    const newQuarterYear = `${newYear}-Q${quarter}`;
    if ( newQuarterYear != this.quarterYear ) {
      this.quarterYear = newQuarterYear;

      // Load quarterly report based on the computed quarter
      this.loadQuarterlyReport(+newYear, quarter);
    }


  }
}
